const searchServiceMixin = {
    data: function () {
        return {
            SEARCH_BASE: '/Api/Search/'
        }
    },
    methods: {
        getSearchResults: function(data) {
            return this.post(this.SEARCH_BASE, 'UpdateResults', data);
        }
    }
}